<template>
  <li>
    <details
      :class="[
        { 'first-level': tag.firstLevel },
        cssBackground,
        'facet-details',
      ]"
      v-if="tag.children.length"
    >
      <summary>
        <label :class="[{ disabled: tag.isDisabled }, 'checkbox-yellow']">
          <input
            type="checkbox"
            :checked="tag.isSelected"
            :disabled="tag.isDisabled"
            @change="selectItem(tag)"
          />
          <div class="checkbox-yellow__indicator"></div>
          {{ tag.name }}
          <span>&nbsp;({{ tag.count }})</span>
        </label>
        <span class="icon-accordion_caret_down fs-5"></span>
      </summary>
      <div class="ps-2 py-1" role="list">
        <facet-dropdown-list-item
          :tag="child"
          v-for="(child, index) in tag.children"
          :key="index"
          @childSelected="childSelected(tag)"
          @mousedown="preventFocus"
        />
      </div>
    </details>

    <label :class="[{ disabled: tag.isDisabled }, 'checkbox-yellow']" v-else>
      <input
        type="checkbox"
        :checked="tag.isSelected"
        :disabled="tag.isDisabled"
        @change="selectItem(tag)"
      />
      <div class="checkbox-yellow__indicator"></div>
      {{ tag.name }}
      <span>&nbsp;({{ tag.count }})</span>
    </label>
  </li>
</template>

<script>
export default {
  name: "FacetDropdownListItem",
  props: ["tag", "cssBackground"],
  components: {},
  computed: {},
  mounted() {
    // Bloody mess, do we need this??
    const details = document.querySelectorAll("details:not(.first-level)");
    // Add the onclick listeners.
    details.forEach((targetDetail) => {
      targetDetail.addEventListener("click", (event) => {
        event.stopPropagation();
        // Close all the sibling details that are not targetDetail.
        const siblings =
          targetDetail.parentElement.parentElement.querySelectorAll("details");
        siblings.forEach((detail) => {
          if (detail !== targetDetail) {
            detail.removeAttribute("open");
          }
        });
      });
    });
    const firstLevelDetails = document.querySelectorAll("details.first-level");

    firstLevelDetails.forEach((firstLevelTarget) => {
      firstLevelTarget.addEventListener("click", () => {
        firstLevelDetails.forEach((firstLevel) => {
          if (firstLevel !== firstLevelTarget) {
            firstLevel.removeAttribute("open");
            const nestedDetails = firstLevel.querySelectorAll("details");
            if (nestedDetails)
              nestedDetails.forEach((nestedDetail) =>
                nestedDetail.removeAttribute("open")
              );
          }
        });
      });
    });
  },
  methods: {
    selectItem: function (tag) {
      this.$store.dispatch("selectItem", tag.id);
      if (!tag.firstLevel && tag.isSelected) {
        this.$emit("childSelected", null);
      }
    },
    childSelected: function (tag) {
      if (!tag.isSelected) {
        this.selectItem(tag);
      } else {
        this.$emit("childSelected", null);
      }
    },
    preventFocus: function (event) {
      // Prevents focus styling on click
      event.preventDefault();
    },
  },
};
</script>

